import { createSlice } from '@reduxjs/toolkit';

const initialState: string | null = null;

const rutaSesionKeySlice = createSlice({
	name: 'rutaSesionKey',
	initialState,
	reducers: {
		setCurrentRutaSesionKey: (state, action) => {
			return action.payload;
		}
	}
});

export const { setCurrentRutaSesionKey } = rutaSesionKeySlice.actions;

export default rutaSesionKeySlice.reducer;
